import React from 'react';
import PensionCalculatorPage from '../PensionCalculatorPage';
import NativeCalculator from '../NativeCalculator';
import { pensionCalculators } from '../access';
import config from './config';

const calculator = pensionCalculators.find(item => item.id === 'weighted-average');

export default function WeightedAveragePage() {
  return (
    <PensionCalculatorPage calculator={calculator}>
      <NativeCalculator calculator={calculator} config={config} />
    </PensionCalculatorPage>
  );
}
